import "./ButtonVariableManager.css";
import NiceModal from '@ebay/nice-modal-react'
import VariablesManager from "../../Variables/VariablesManager/VariablesManager";
import useShiftKey from '../../../hook/useShiftKey';

// Component for calling the VariableManager on the editor-window : popup on the right
function ButtonVariableManager() {

    const { changeShiftKey, shiftKey } = useShiftKey();

    const onClick = () => {
        shiftKey ? changeShiftKey() : null;
        NiceModal.show('editor-window', { Component : VariablesManager })
    }

    return <div className="variable_manager" onClick={onClick}></div>
}

export default ButtonVariableManager;